var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { CaptionWrapper } from "../../desktopApp/longread/postblocks/components/votedragcolumn";
import MultipleCaptionEdit from "../../desktopApp/longread/postblocks/components/MultipleCaptionEdit";
import CaptionEdit from "../../desktopApp/longread/editor/CaptionEdit";
var CaptionsWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .capt {\n    z-index: 8;\n  }\n"], ["\n  .capt {\n    z-index: 8;\n  }\n"])));
export var CaptionComponent = function (_a) {
    var isLoading = _a.isLoading, isEditing = _a.isEditing, isMultiple = _a.isMultiple, hasSliderText = _a.hasSliderText, mode = _a.mode, text = _a.text, link = _a.link, maxCaptionLength = _a.maxCaptionLength, multipleValue = _a.multipleValue, placeholder = _a.placeholder, maxLength = _a.maxLength, onSubmit = _a.onSubmit, onCancel = _a.onCancel, hide = _a.hide;
    if (!isEditing || isLoading || hasSliderText)
        return null;
    if (isMultiple) {
        return (React.createElement(CaptionsWrapper, null,
            React.createElement(CaptionWrapper, { hide: textRaw === null || textRaw === void 0 ? void 0 : textRaw.length },
                React.createElement(MultipleCaptionEdit, { value: multipleValue, onSubmit: onSubmit, onCancel: onCancel, isMultiLoad: true }))));
    }
    if (mode === 'link_mode') {
        return (React.createElement(CaptionsWrapper, null,
            React.createElement(CaptionEdit, { variant: 'mini', value: link, placeholder: placeholder, maxLength: maxCaptionLength, onSubmit: onSubmit, onCancel: onCancel })));
    }
    return (React.createElement(CaptionsWrapper, null,
        React.createElement(CaptionEdit, { variant: 'mini', value: text, maxLength: maxCaptionLength, onSubmit: onSubmit, onCancel: onCancel })));
};
var templateObject_1;
//# sourceMappingURL=CaptionComponent.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { CaptionWrapper } from "../../desktopApp/longread/postblocks/components/votedragcolumn";
import MultipleCaptionEdit from "../../desktopApp/longread/postblocks/components/MultipleCaptionEdit";
import CaptionEdit from "../../desktopApp/longread/editor/CaptionEdit";
var CaptionsWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .capt {\n    z-index: 8;\n  }\n"], ["\n  .capt {\n    z-index: 8;\n  }\n"])));
export var CaptionComponent = function (_a) {
    var isLoading = _a.isLoading, isEditing = _a.isEditing, isMultiple = _a.isMultiple, hasSliderText = _a.hasSliderText, mode = _a.mode, text = _a.text, link = _a.link, maxCaptionLength = _a.maxCaptionLength, multipleValue = _a.multipleValue, placeholder = _a.placeholder, maxLength = _a.maxLength, onSubmit = _a.onSubmit, onCancel = _a.onCancel, hide = _a.hide;
    if (!isEditing || isLoading || hasSliderText)
        return null;
    if (isMultiple) {
        return (React.createElement(CaptionsWrapper, null,
            React.createElement(CaptionWrapper, { hide: textRaw === null || textRaw === void 0 ? void 0 : textRaw.length },
                React.createElement(MultipleCaptionEdit, { value: multipleValue, onSubmit: onSubmit, onCancel: onCancel, isMultiLoad: true }))));
    }
    if (mode === 'link_mode') {
        return (React.createElement(CaptionsWrapper, null,
            React.createElement(CaptionEdit, { variant: 'mini', value: link, placeholder: placeholder, maxLength: maxCaptionLength, onSubmit: onSubmit, onCancel: onCancel })));
    }
    return (React.createElement(CaptionsWrapper, null,
        React.createElement(CaptionEdit, { variant: 'mini', value: text, maxLength: maxCaptionLength, onSubmit: onSubmit, onCancel: onCancel })));
};
var templateObject_1;
//# sourceMappingURL=CaptionComponent.js.map